import React, { Component } from "react";
import { withDataAnalyse } from "../../../../shared/containers/containerDataAnalyse";
import { CanvasJSChart } from "canvasjs-react-charts";

class DataAnalyseChart extends Component {
  getDataValues() {
    const { simpleSignals } = this.props;

    const dataValues = {};

    simpleSignals.forEach((simpleSignal) => {
      Object.keys(simpleSignal.data).forEach((key) => {
        if (key !== "TI") {
          if (!dataValues[key]) {
            dataValues[key] = {
              name: key,
              type: "line",
              showInLegend: true,
              yValueFormatString: "#.### ",
              xValueFormatString: "DD MM YYYY HH:mm:ss",
              visible: false,
              dataPoints: [],
            };
          }

          dataValues[key].dataPoints.push({
            x: new Date(simpleSignal.data["TI"].value.replace("Z", "")),
            y: simpleSignal.data[key].value,
            markerSize: 1.5,
          });
        }
      });
    });

    return dataValues;
  }

  getChartOptions(height = 330) {
    const options = {
      height: height,
      theme: "dark",
      animationEnabled: true,
      zoomEnabled: true,
      exportEnabled: true,
      toolTip: {
        shared: true,
      },
      legend: {
        horizontalAlign: "center",
        verticalAlign: "top",
        cursor: "pointer",
        itemclick: function (e) {
          if (typeof e.dataSeries.visible === "undefined" || e.dataSeries.visible) {
            e.dataSeries.visible = false;
          } else {
            e.dataSeries.visible = true;
          }

          e.chart.render();
        },
      },
      axisX: {
        valueFormatString: "DD.MM.YYYY HH:mm",
      },
      axisY: {
        crosshair: {
          enabled: true,
          snapToDataPoint: true,
        },
      },
      showInLegend: true,
      data: Object.values(this.getDataValues()),
    };

    return options;
  }

  render() {
    return <CanvasJSChart options={this.getChartOptions()} />;
  }
}

export default withDataAnalyse(DataAnalyseChart);
